import firebase from "firebase/compat/app";
import "firebase/compat/database";
import { environment } from "./constant";

const firebaseConfig = {
  apiKey: "AIzaSyCwdEs5CPv7NLbcLHs47cxVIrD9ElH3d6Y",
  authDomain: "sitemaster-73204.firebaseapp.com",
  databaseURL: "https://sitemaster-73204-default-rtdb.firebaseio.com",
  projectId: "sitemaster-73204",
  storageBucket: "sitemaster-73204.firebasestorage.app",
  messagingSenderId: "97124326033",
  appId: "1:97124326033:web:f7a2cbb236583123393d30",
  measurementId: "G-LJB1G81837",
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

const rtdb = firebase.database();

export const getToken = async (userId) => {
  const values = await rtdb
    .ref(`userTokens-${environment}/${userId}`)
    .once("value");
  return values.val() ?? {};
};

export const sendPushNotification = async (
  expoPushToken,
  title,
  body,
  screenData = null
) => {
  const message = {
    to: expoPushToken,
    sound: "default",
    title: title,
    body: body,
    data: screenData || {}, // Include screen navigation data
  };

  const res = await fetch("https://exp.host/--/api/v2/push/send", {
    method: "POST",
    mode: "no-cors",
    headers: {
      Accept: "application/json",
      "Accept-encoding": "gzip, deflate",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(message),
  });

  if (!res.ok) {
    console.error("Error sending push notification:", res.status);
    return false;
  }
  const data = await res.json();
  if (data.errors) {
    console.error("Error sending push notification:", data.errors);
    return false;
  }
  // console.log("Push notification sent successfully:", data);
};

export { firebase, rtdb };
